export default "/wp-content/themes/onnit/script/cart/dist/thankyou-5ee24878.gif";